export default {
  applicantName: '',
  address: '',
  addressDetail: '',
  contact1: '',
  deliveryMemo: '',
  patientInfo: '',
  __typename: 'CheckoutAddress'
};
